// extracted by mini-css-extract-plugin
export var chevronIcon = "_9r-2";
export var teamName = "_9r-1";
export var teamSwitcherButton = "_9r-0";